var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-stack h-stretch gap-3"},[_c('LogViewer',{attrs:{"category":'project',"reference":_vm.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }